// Per-country overrides (non-European countries and European countries with their own currency)
const countryCurrencyOverrides = {
  GB: "GBP",
  UK: "GBP",
  CH: "CHF",
  DK: "DKK",
  NO: "NOK",
  SE: "SEK",
  AU: "AUD",
  NZ: "NZD",
  JP: "YEN",
  HK: "HKD",
  BR: "BRL",
  ZA: "ZAR",
  CA: "CAD",
  US: "USD",
};

const eurozoneCountries = [
  "AT", "BE", "HR", "CY", "EE", "FI", "FR", "DE", "GR", "IE",
  "IT", "LV", "LT", "LU", "MT", "NL", "PT", "SK", "SI", "ES",
];

function resolveCurrency(response) {
  const countryCode = response.country && response.country.iso_code;

  if (countryCode && countryCurrencyOverrides[countryCode]) {
    return countryCurrencyOverrides[countryCode];
  }

  if (countryCode && eurozoneCountries.includes(countryCode)) {
    return "EUR";
  }

  return "USD";
}

function applyCurrency(currencyCode) {
  if (!window.EXCHANGE || !window.EXCHANGE.currencies[currencyCode]) {
    return;
  }

  window.EXCHANGE.current_currency = currencyCode;
  localStorage.setItem("saved_currency", currencyCode);

  const currencyElements = document.querySelectorAll("#selected-currency-desktop, #selected-currency-mobile");
  currencyElements.forEach((el) => {
    el.dataset.cur = currencyCode;
    el.innerText = currencyCode;
  });

  document.querySelector("html").dataset.currency = currencyCode;

  if (typeof window.EXCHANGE.run === "function") {
    window.EXCHANGE.run();
  }
}

function setAutoCurrency() {
  if (localStorage.getItem("saved_currency")) {
    return;
  }

  if (typeof geoip2 === "undefined") {
    return;
  }

  geoip2.country(
    (response) => {
      try {
        applyCurrency(resolveCurrency(response));
      } catch (error) {
        console.error("Error setting auto currency:", error);
      }
    },
    (error) => {
      console.error("GeoIP2 error:", error);
    }
  );
}

// Run after DOM is loaded and EXCHANGE is initialized
document.addEventListener("DOMContentLoaded", () => {
  // Try to wait for EXCHANGE object to be fully initialized
  let attempts = 0;
  const maxAttempts = 10;

  function trySetCurrency() {
    attempts++;

    if (window.EXCHANGE && window.EXCHANGE.currencies) {
      setAutoCurrency();
    } else if (attempts < maxAttempts) {
      setTimeout(trySetCurrency, 1000);
    } else {
    }
  }

  trySetCurrency();
});
